import React, { useState, useRef } from "react";
import clientData from "../clientData";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./client.css";
import Slider from "react-slick";
import { AiFillStar } from "react-icons/ai";
import mark from "./mark.png";
import mark2 from "./mark2.png";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const Client = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);

  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  const handlePrev = () => {
    sliderRef.current.slickPrev();
  };

  const settings = {
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    centerMode: true,
    // dots: true,
    centerPadding: "0px",
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    responsive: [
      {
        breakpoint: 1024, // Settings for screens less than 1024px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600, // Settings for screens less than 600px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
    appendDots: (dots) => (
      <div style={{ bottom: "-50px" }}>
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor:
            currentSlide === i ? "white" : "rgba(255, 255, 255, 0.5)",
          display: "inline-block",
          margin: "0 5px",
        }}
      />
    ),
  };

  return (
    <div className="what_our_clients_say lg:w-10/12 w-12/12 mx-auto my-10">
      <h1
        className="lg:text-5xl md:text-3xl text-2xl font-bold text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        What our{" "}
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#E10B7B] via-[#652D90 ] to-[#1C85C7]">
          Clients
        </span>{" "}
        say?
      </h1>

      {/* For device with high width sizes */}
      <div
        className="review_container md:my-20 my-8 mx-2"
        {...settings}
        ref={sliderRef}
      >
        {clientData.map((data, index) => (
          <div
            key={index}
            className="main_review_container rounded-2xl transition-transform duration-500 ease-in-out"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="2em"
              height="2em"
              viewBox="0 0 1200 1200"
            >
              <rect width="1200" height="1200" fill="none" />
              <path
                fill="#888"
                d="M600 0C268.629 0 0 268.629 0 600s268.629 600 600 600s600-268.629 600-600S931.371 0 600 0m-45.923 282.422l25.781 118.727c-75.541 16.721-145.005 38.468-139.38 122.826h88.77v315.968H261.841V544.629c.095-234.691 172.401-253.786 292.236-262.207m358.228 0l25.854 118.727c-75.541 16.721-145.005 38.468-139.38 122.826h88.77v315.968H620.142V544.629c.094-234.691 172.328-253.786 292.163-262.207"
              />
            </svg>
            <h3 className="review_paragraph">{data.paragraph}</h3>
            <div className="client_review_details_container d_flex">
              <div className="client_image_and_name d_flex">
                <img
                  className="review_image"
                  src={data.image}
                  alt="Review_image"
                />
                <div className="name_and_company">
                  <span>{data.name}</span>
                  <h5>Honey Bee Pvt LTD</h5>
                </div>
              </div>
              <div className="star_container d_flex">
                {Array.from({ length: 5 }).map((_, index) => (
                  <span key={index}>
                    <AiFillStar className="star_icon" />
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* For device with low width sizes */}
      <div
        className="review_container slider-container md:my-20 my-8 mx-2"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        {/* use <Slider></Slider> instead of <div></div> if slider is needed */}
        <Slider
          className="slider_review_container"
          {...settings}
          ref={sliderRef}
        >
          {clientData.map((data, index) => (
            <div
              key={index}
              className="main_review_container !flex h-full slider_main_review_container rounded-2xl transition-transform duration-500 ease-in-out"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2em"
                height="2em"
                viewBox="0 0 1200 1200"
              >
                <rect width="1200" height="1200" fill="none" />
                <path
                  fill="#fff"
                  d="M600 0C268.629 0 0 268.629 0 600s268.629 600 600 600s600-268.629 600-600S931.371 0 600 0m-45.923 282.422l25.781 118.727c-75.541 16.721-145.005 38.468-139.38 122.826h88.77v315.968H261.841V544.629c.095-234.691 172.401-253.786 292.236-262.207m358.228 0l25.854 118.727c-75.541 16.721-145.005 38.468-139.38 122.826h88.77v315.968H620.142V544.629c.094-234.691 172.328-253.786 292.163-262.207"
                />
              </svg>
              <h3 className="review_paragraph">{data.paragraph}</h3>
              <div className="client_review_details_container d_flex">
                <div className="client_image_and_name d_flex">
                  <img
                    className="review_image"
                    src={data.image}
                    alt="Review_image"
                  />
                  <div className="name_and_company">
                    <span>{data.name}</span>
                    <h5>Honey Bee Pvt LTD</h5>
                  </div>
                </div>
                <div className="star_container d_flex">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <span key={index}>
                      <AiFillStar className="star_icon" />
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </Slider>
        {/* <div className="flex text-4xl items-center gap-4 absolute left-1/2 -translate-x-1/2 -bottom-10">
          <button
            onClick={handlePrev}
            className="cursor-pointer border rounded-full bg-white text-black duration-300 active:!bg-black active:!text-white"
          >
            <MdKeyboardArrowLeft />
          </button>
          <button
            onClick={handleNext}
            className="cursor-pointer border rounded-full bg-white text-black duration-300 active:!bg-black active:!text-white"
          >
            <MdKeyboardArrowRight />
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Client;
